import Icons from '@/constants/Icons';
import RouteNames from '@/constants/RouteNames';
import AppAction from '@/models/core/AppAction';

export const hardwareListAction = () =>
  new AppAction({
    icon: Icons.Hardware,
    name: RouteNames.Hardware.List,
    route: { name: RouteNames.Hardware.List },
  });
